// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__GaY7i","create-modal":"styles_create-modal__MHVSS"};